<template>
<LayoutContainer columns="40/60">

<v-toolbar slot="header" dark class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title>Templates for {{officeName}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on">more_vert</v-icon>
        </template>
        <v-list>
            <v-list-item>
                <v-list-item-title>Office {{tenantKey}}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="goToTemplateMaintenance">
                <v-list-item-title>Template Maintenance</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</v-toolbar>



<div slot="col1" pa-3>
    <div class="pa-3" style="flex-basis:0">
        <input type="text" ref="search" v-model="search" placeholder="Search..."  class="no-border full-width">
    </div>
    <div style="overflow:auto">
        <v-list two-line subheader>
            <v-list-item :class="{'border-transparent': true, 'blue-hilight':(template.key == tmpl.key)}" :disabled="editing"
            v-for="tmpl in visibleTemplates" v-bind:key="tmpl.key" @click="selectTemplate(tmpl)">
                <v-list-item-content>
                <v-list-item-title>{{ tmpl.group }} - {{ tmpl.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ tmpl.subject }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                <v-btn icon ripple>
                    <v-icon class="grey--text text--lighten-1">info</v-icon>
                </v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list>
    </div>
</div>


    <!-- ***************** Right Column ******************* -->
    <div slot="col2">
        <div class="ml-4 mr-2">
        <div>
            <div>
                <v-text-field hide-details v-model="template.group" label="Group" prepend-icon="note"></v-text-field>
            </div>
            <div>
                <v-text-field hide-details v-model="template.name" label="Name" prepend-icon="widgets"></v-text-field>
            </div>

        </div>
        <v-text-field hide-details v-model="template.subject" label="Subject"></v-text-field>
        <br/>

        <!-- Have tried:
        ckEditor 5 : Link textbox would not accept any input, and image required plumbing for upload
        trix editor. Was not updating editor content on template change.
        vue-2-editor. quill wrapper. failed on prod build...see: https://github.com/davidroyer/vue2-editor/issues/104
        medium-editor. problems with mobile.
        summernote needs both jquery and bootstrap.
        froala waiting on issue: https://github.com/froala/vue-froala-wysiwyg/issues/91
        -->
        <!-- waiting on issue: https://github.com/froala/vue-froala-wysiwyg/issues/91
        <froala style="border-radius:3px;" id="edit123" :tag="'textarea'" :config="config" v-model="template.body"></froala> -->
        <!-- <Editor v-model="template.body" mode="wysiwyg" :options="tuiOptions"/> -->
        <!-- <vue-editor v-model="template.body" :editorToolbar="customToolbar"></vue-editor> -->
        <!-- <VueTrix v-model="test" placeholder="" localStorage/> -->
        <HtmlEditor v-model="template.body" />
        <!-- <ckeditor :editor="editor" v-model="template.body" :config="editorConfig" /> -->

        <v-switch v-model="template.personal" color="primary" style="margin-top:0px" hide-details label="Personal Template" light></v-switch>
        <br/>
        <DeleteButton @delete="deleteTemplate" :disabled="!template.key" style="float:right"></DeleteButton>
        <v-btn icon text color="grey" style="float:right" @click="viewHtml"><v-icon>text_fields</v-icon></v-btn>
        <v-btn :disabled="!editing" color="primary" @click="saveTemplate">Save</v-btn>
        <v-btn :disabled="!editing" @click="cancelEditing">Cancel</v-btn>
        <v-btn text :disabled="!template.key || editing" @click="copyTemplate">Make a Copy</v-btn>
        <v-textarea v-if="viewHtmlBox" label="HTML View" :rows="10" v-model="template.body"></v-textarea>
        </div>
    </div>
    <!-- End right column -->



</LayoutContainer>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'

import firebase from 'firebase/app'
import 'firebase/database'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import VueFire from 'vuefire'

import ContactHelpers from '../helpers/ContactHelpers'
import DataHelpers from '../helpers/DataHelpers'
import DeleteButton from '../ui-elements/DeleteButton'
import UserChooser from '../ui-elements/UserChooser'

import HtmlEditor from '../ui-elements/HtmlEditor'

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter'

// import { VueEditor } from "vue2-editor"
// import VueTrix from "vue-trix"

//In progress...
// import 'tui-editor/dist/tui-editor.css';
// import 'tui-editor/dist/tui-editor-contents.css';
//import 'codemirror/lib/codemirror.css';
// import Editor from '@toast-ui/vue-editor/src/Editor.vue'

var db = firebase.database()

export default {
    name: 'Templates',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                // plugins: [SimpleUploadAdapter],
                image: {
                    upload: {
                        panel: {
                            items: [ 'insertImageViaUrl' ]
                        }
                    }
                },

            },
            search: '',
            editing: false,
            viewHtmlBox: false,
            template: {
                name: null,
                group: null,
                subject: null,
                body: '',
                personal: null
            },
            // customToolbar: [
            //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            //     ["bold", "italic", "underline"],
            //     [{ list: "ordered" }, { list: "bullet" }, {list: "check"}],
            //     ["link", "blockquote"],
            //     [{ 'color': [] }, { 'background': [] }],
            //     ['clean']
            // ],
            // config: {
            //     // toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'help', 'html', '|', 'undo', 'redo'],
            //     toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'help', 'html', '|', 'undo', 'redo'],
            //     events: {
            //     initialized: function () {
            //         console.log('initialized')
            //     }
            //     }
            // },
            // tuiOptions: {
            //     hideModeSwitch: false,
            //     toolbarItems: [
            //         'heading',
            //         'bold',
            //         'italic',
            //         //'strike',
            //         'divider',
            //         //'hr',
            //         'quote',
            //         //'divider',
            //         'ul',
            //         'ol',
            //         //'task',
            //         'indent',
            //         'outdent',
            //         'divider',
            //         'table',
            //         'image',
            //         'link',
            //         'divider',
            //         //'code',
            //         //'codeblock'
            //     ]
            // },
        }
    },

    components: {
        DeleteButton,
        LayoutContainer,
        HtmlEditor,
        // Editor,
        // VueEditor,
        // VueTrix,
    },

    props: {
        selectedKey: String,
    },

    // firebase() {
    //     return {
    //         liveTemplates: templatesRef
    //     }
    // },
    computed:{

        templates () {
            return this.$store.getters.templates
        },

        tenantKey() {
            return this.$store.getters.tenantKey
        },

        officeName() {
            return DataHelpers.officeName()
        },

        visibleTemplates() {
            if(!this.search)
                return this.templates

            let search =this.search.toLowerCase()

            return this.templates.filter(o => o.name && o.name.contains(search) || o.group && o.group.contains(search))

        }



    },

    watch: {
        template: {
            handler: function (newVal, oldVal) {
                console.log('template changed', oldVal.body, newVal.body )
                this.editing = true
            },
            deep: true
        },
        selectedKey: {
            handler: function (newVal) {
                console.log('selectedKey changed...')
                this.loadTemplate(newVal)
            },
            immediate: false
        },
    },

    methods: {
        updateBody (html) {
            this.template.body = html
        },

        loadTemplate(key) {
            let matchingTemplate = this.templates.find(o => o.key == key)
            if(!matchingTemplate) {
                console.log('cant find matching template...')

                return
            }

            //temporary to clean divs from old editor
            //matchingTemplate.body = matchingTemplate.body.replace(/<div>/gi, '').replace(/<\/div>/gi, '')

            this.template = {...matchingTemplate}
            setTimeout( () => {
                this.editing = false
            },10)
        },

        selectTemplate (template) {
            this.$router.push('/templates/' + template.key)
        },

        saveTemplate () {
            console.log('Saving template')
            this.$store.dispatch('saveTemplate', this.template)
            this.editing = false
        },

        cancelEditing () {
            this.resetTemplate()
        },

        copyTemplate () {
            console.log('Copying template')
            let template = FirebaseHelpers.cloneWithoutKey(this.template)
            template.name += ' (copy)'
            template.key = DataHelpers.getKey()
            this.$store.dispatch('saveTemplate', template)
            this.selectTemplate(template)

        },
        deleteTemplate () {
            console.log('Deleting template')
            this.$store.dispatch('deleteTemplate', this.template)

            const sourceTemplate = this.templates[0]
            this.template = JSON.parse(JSON.stringify(sourceTemplate))
            setTimeout(()=>{
                this.editing = false
                console.log('editing set false')
            },300)
        },
        resetTemplate () {
            let sourceTemplate = this.templates.find(o => o.key == this.template.key)
            this.template = JSON.parse(JSON.stringify(sourceTemplate))
            setTimeout(()=>{
                this.editing = false
                console.log('editing set false')
            },300)


        },
        goToTemplateMaintenance() {
            this.$router.push('/maintenance/?action=tot&item=' + this.selectedKey)
        },
        viewHtml() {
            this.viewHtmlBox = true
        }

    },
    created () {
        console.log('templates > created')
        this.$store.dispatch('loadTemplates').then(() => {
            this.loadTemplate(this.selectedKey)
        })
    },
    mounted () {
        this.$refs.search.focus()
    }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Templates.vue?d62b6856